module.exports = __webpack_public_path__ + "img/project1.0ea04c40.jpg";